import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";

const NotetypeCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [bank, setBank] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id); // Send ID in the form data
      formData.append("userId", userId);
      const result = await fetchFormData("notetype/getById", formData, "POST");

      if (result && result.data) {
        setBank(result.data.typename);
      } else {
        console.warn("Bank data not found.");
        setBank("");
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      setBank("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create a FormData object
    const formData = new FormData();
    formData.append("typename", bank);
    formData.append("status", 1);
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);

    try {
      let res;

      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        // Edit logic - update
        res = await fetchFormData("notetype/update", formData, "POST");
        console.log("Updating note ype:", id, formData);
      } else {
        // Create logic - new
        res = await fetchFormData("notetype/insert", formData, "POST");
        console.log("Creating new note type:", formData);
      }

      if (res && res.message === "Note type created successfully") {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate(`/master/note-type-list?id=${M_id}`);
        console.log(" operation successful", res);
      } else if (res && res.message === "Note type updated successfully") {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate(`/master/note-type-list?id=${M_id}`);
        console.log(" operation successful", res);
      } else {
        console.error(" operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Note type:" : "Add Note type:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit} className="row g-3">
              <div className="col-md-6">
                <Input
                  label="Note type Name"
                  name="note_type_name"
                  value={bank}
                  onChange={(name, value) => setBank(value)}
                  placeholder="Note type Name"
                  icon="feather-hash"
                  required
                />
              </div>
              <div className="col-md-6">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotetypeCreate;
